// Example usage in a modal
import { Modal } from 'antd';
import PurchaseOrderDetailComponent from './PurchaseOrderDetail';
import { InventoryDocument } from 'models';
import { FancySpinner } from 'components/common';
import { PurchaseOrderStatusCode } from 'types';
import { X } from '@phosphor-icons/react';
import { useImportOrderOperations } from 'hooks/useImportOrderOperations';
interface PurchaseOrderDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  purchaseOrderId: string;
  handleImport: (order: InventoryDocument) => void;
}

const PurchaseOrderDetailModal: React.FC<PurchaseOrderDetailModalProps> = ({
  isOpen,
  onClose,
  purchaseOrderId,
  handleImport,
}) => {
  const { currentPurchaseOrder, transactions, isLoading, handleOnNewFileUpload, filesData, setFilesData } =
    useImportOrderOperations({
      purchaseOrderId,
      isModalView: true,
    });
  function handlePrint(): void {}

  return !isLoading ? (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1800}
      destroyOnClose={true}
      bodyStyle={{ padding: 0 }}
      closeIcon={false}
      centered
      className='modal-none-padding '
    >
      {/* {isModalView && ( */}
      <div className='flex justify-between items-start bg-white p-6 pb-2 rounded-tl-[16px] rounded-tr-[16px]'>
        <div className='flex flex-col gap-2'>
          <h2 className='leading-[24px] text-[20px] font-bold text-[var(--textBlack100)]'>CHI TIẾT PHIẾU NHẬP</h2>
          <p className='text-sm text-[var(--textGray)] mb-6'>
            Bạn cần kiểm tra thông tin, in phiếu và thực hiện kiểm tra thủ công. Sau đó, nhấn nút bắt đầu nhập hàng và
            nhập số lượng thực tế lên hệ thống.
          </p>
        </div>

        <button
          onClick={onClose}
          className='text-[var(--textBlack100)] w-[44px] h-[40px] bg-[var(--textBlack4)] flex items-center justify-center rounded-lg'
        >
          <X size={20} />
        </button>
      </div>
      {/* )} */}
      <PurchaseOrderDetailComponent
        purchaseOrder={currentPurchaseOrder}
        onClose={onClose}
        onImport={() => handleImport(currentPurchaseOrder)}
        onPrint={handlePrint}
        recivied={currentPurchaseOrder.status?.code === PurchaseOrderStatusCode.RECEIVED}
        transactions={transactions}
        className='max-h-[calc(100vh-100px)] overflow-y-auto'
        filesData={filesData}
        onNewFileUpload={handleOnNewFileUpload}
        setFilesData={setFilesData}
      />
    </Modal>
  ) : (
    <div className='fixed inset-0 flex items-center justify-center bg-white/70 z-50'>
      <FancySpinner size='large' colorScheme='blue' text='Đang tải dữ liệu...' overlay={true} />
    </div>
  );
};

export default PurchaseOrderDetailModal;
